import { Text, TouchableOpacity, Image, View, ScrollView } from 'react-native';
import React from 'react';
import { categoryStyles } from '../styles/category';

const items = [
  {
    image: require('../../assets/fish-salad.jpg'),
    title: 'Meals',
  },
  {
    image: require('../../assets/dessert1.png'),
    title: 'Dessert',
  },
  {
    image: require('../../assets/burger.jpg'),
    title: 'Fast food',
  },
  {
    image: require('../../assets/veggie02.jpg'),
    title: 'Veggies',
  },
  {
    image: require('../../assets/pastry.jpg'),
    title: 'Pastry',
  },
  {
    image: require('../../assets/soda.jpg'),
    title: 'Soft Drink',
  },
  {
    image: require('../../assets/coffee.jpg'),
    title: 'Tea & Coffee',
  },
];

const CategoryCard = () => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={categoryStyles.wrapper}>
      {items.map((item, index) => (
        <View key={index}>
          <TouchableOpacity>
            <Image source={item.image} style={categoryStyles.topImage} />

            <Text style={categoryStyles.topText}>{item.title}</Text>
          </TouchableOpacity>
        </View>
      ))}
    </ScrollView>
  );
};

export default CategoryCard;
